// extracted by mini-css-extract-plugin
export default {"button":"RkiDjb","formButton":"mcFSJR","form":"G5776v","error":"EseMxk","summaryBlock":"dZYrPI","title":"Jf36uE"};